import { inject, type App } from 'vue'
import {
  init,
  browserTracingIntegration,
  httpClientIntegration,
  thirdPartyErrorFilterIntegration
  // replayIntegration
} from '@sentry/vue'
import { isProbablyBlockedByAdblockNetworkError } from './sentry/adblock'

type Sentry = ReturnType<typeof initSentry>

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $sentry: Sentry
  }
}

const dsn = String(import.meta.env.VITE_SENTRY_DSN || '')
const host = String(import.meta.env.VITE_SHOPIFY_URL)
const environment = String(import.meta.env.VITE_SENTRY_ENV || (host.includes('oats-3') ? 'production' : 'staging'))

export const key = Symbol('sentry')
export const useSentry = () => inject<Sentry>(key)

const IGNORE_REGEX = /(retry count|illegal invocation|AbortError|request aborted|aborterror|unhandledrejection|open database file|database deleted|shopifycloud|monorail|network error|object not found matching|shopify-fueled-client|ConstraintError|UnknownError:)/i

const initSentry = (app: App) => {
  return init({
    app,
    dsn,
    environment,
    // debug: environment === 'dev',
    ignoreErrors:[
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      /Failed to initialize Amplitude/,
      /fueled\.io/,
      IGNORE_REGEX
    ],
    beforeSend(event) {
      if (isProbablyBlockedByAdblockNetworkError(event)) {
        return null
      }
      return event
    },
    integrations: [
      browserTracingIntegration(),
      httpClientIntegration(),
      thirdPartyErrorFilterIntegration({
        filterKeys: [ 'oatsovernight.com' ],
        behaviour: 'drop-error-if-contains-third-party-frames'
      })
      // replayIntegration({
      //   maskAllText: false,
      //   blockAllMedia: false,
      //   networkDetailAllowUrls: [
      //     'localhost',
      //     'http://127.0.0.1',
      //     // Shopify
      //     'https://oatsdev.myshopify.com', //staging
      //     'https://oats-3.myshopify.com', //prod
      //     'https://www.oatsovernight.com', //prod
      //     // Recharge
      //     'https://api.rechargeapps.com',
      //     // Supabase
      //     'https://lgblhlvuqnoyvsdhtwuu.supabase.co', // staging
      //     'https://kwquouvcmhpmlvwhhiqs.supabase.co', // prod
      //     // Oatbiz
      //     'https://staging.oatbiz.com', // staging
      //     'https://app.oatbiz.com' // prod
      //   ]
      // })
    ],
    // Performance Monitoring
    tracesSampleRate: 0.005,
    // Session Replay
    // replaysSessionSampleRate: 0.001,
    replaysOnErrorSampleRate: 0.05
  })
}

export const sentryPlugin = {
  install(app: App) {
    const sentry = initSentry(app)
    app.provide(key, sentry)
    app.config.globalProperties.$sentry = sentry
  }
}

export default sentryPlugin
